import { Component, DestroyRef, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { EntryService } from '../entry.service';
import { Store } from '@ngrx/store';
import { UtilService } from 'src/app/util.service';
import { EntryData, TedDomain } from '../structure-data.models';;
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { PlatformService } from 'src/app/platform.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { combineLatest, filter, map, tap } from 'rxjs';
const COUNT_LEGENDS = 12;

@Component({
  selector: 'app-legends-panel',
  templateUrl: './legends-panel.component.html',
  styleUrl: './legends-panel.component.css',
  standalone: false
})
export class LegendsPanelComponent {
  // @Input() tedDomainData;
  // @Input() csvAmData;
  @Output() toggleAccordion: EventEmitter<Object> = new EventEmitter();
  private store = inject(Store);
  accession = toSignal(this.store.select(EntrySelectors.accession));
  // entryData = toSignal(this.store.select(EntrySelectors.entryData));
  public entryData = signal<EntryData>({} as EntryData);
  public tedDomainData = signal<TedDomain[]>([]);
  public csvAmData = signal<string>('');
  // tedDomainData = toSignal(this.store.select(EntrySelectors.tedDomainData));
  // csvAmData = toSignal(this.store.select(EntrySelectors.csvAmData));
  private readonly destroyRef = inject(DestroyRef);
  public slicedTedDomain = signal<TedDomain[]>([]);
  public showMoreLegends = signal<boolean>(false);
  public legendText = signal<string>('');
  public colorscheme : string = 'plddt';
  public domainCount : number;
  constructor(
    public gaService: GoogleAnalyticsService,
    private entryService: EntryService,
    public platform: PlatformService,
    public readonly utilService: UtilService
    ) {}

  public domainData = this.entryService.domainData();
  ngOnInit(): void {
    // this.store.select(EntrySelectors.entryData).pipe(filter(Boolean), tap(data => {
    //   return this.entryData.set(data)
    // })).subscribe(() =>{})

    // this.store.select(EntrySelectors.tedDomainData).pipe(filter(Boolean), tap(data => {
    //   return this.tedDomainData.set(data)
    // })).subscribe(() =>{
    //   this.domainCount = this.tedDomainData() ? this.tedDomainData().length : 0;
    //   this.slicedTedDomain.update(() =>
    //     this.tedDomainData()?.slice(0, COUNT_LEGENDS)
    //   );
    //   this.legendText.set(`Show all ${this.tedDomainData()?.length} domains`);
    // })

    // this.store.select(EntrySelectors.csvAmData).pipe(filter(Boolean), tap(data => {
    //   return this.csvAmData.set(data)
    // })).subscribe(() =>{})

    combineLatest([
      this.store.select(EntrySelectors.entryData).pipe(filter(Boolean)),
      this.store.select(EntrySelectors.tedDomainData).pipe(filter(Boolean)),
      this.store.select(EntrySelectors.csvAmData).pipe()
    ])
      .pipe(
        map(([entryData, tedDomainData, csvAmData]) => {
          this.entryData.set(entryData)
          this.tedDomainData.set(tedDomainData)
          this.csvAmData.set(csvAmData)
          this.domainCount = this.tedDomainData() ? this.tedDomainData().length : 0;
          this.slicedTedDomain.update(() =>
            this.tedDomainData()?.slice(0, COUNT_LEGENDS)
          );
          this.legendText.set(`Show all ${this.tedDomainData()?.length} domains`);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
  
  viewerLegend: any = [
    { style: { backgroundColor: '#0053D6' }, label: 'Very high (pLDDT > 90)' },
    { style: { backgroundColor: '#65CBF3' }, label: 'High (90 > pLDDT > 70)' },
    { style: { backgroundColor: '#FFDB13' }, label: 'Low (70 > pLDDT > 50)' },
    { style: { backgroundColor: '#FF7D45' }, label: 'Very low (pLDDT < 50)' },
  ];

  alphamissenseLegends: any = [
    { style: { backgroundColor: '#2166ac' }, label: 'Likely benign' },
    { style: { backgroundColor: '#A8A9AC' }, label: 'Uncertain' },
    { style: { backgroundColor: '#b2182b' }, label: 'Likely pathogenic' },
  ];

  onOpenLegendsPanel(type: string): void {
    const shouldEmit = type === 'plddt' || 
                       (type === 'missense' && this.entryData().amAnnotationsUrl) ||
                       (type === 'ted' && this.tedDomainData()?.length > 0);
  
    if (shouldEmit) {
      this.toggleAccordion.emit({ type });
    }
    this.colorscheme = type;

    //for GA tags
    let tag = "";
    let gtagmsg = "";
    if(type === "plddt"){
      tag = "model_confidence_accordion";
      gtagmsg = "Clicks to expand/collapse Model Confidence legend";
    }
    if(type === "missense"){
      tag = "domains_accordion";
      gtagmsg = "Clicks to expand/collapse Domains accordion";
    }
    if(type === "ted"){
      tag = "annotations_accordion";
      gtagmsg = "Clicks to expand/collapse 'Annotations' accordion";
    }
    this.gaService.eventEmitter('accordion_toggle', 'accordion_expand', 'click', tag, gtagmsg);
  }
}
